var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.35 14.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.88,7.36l4.29,3.86L5.08,14a2.9,2.9,0,0,1-3.79,0l-.51-.45a2.25,2.25,0,0,1,0-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.56,4.57,12.47,7.36,8.17,3.5,11.27.71a2.88,2.88,0,0,1,3.79,0l.5.45A2.24,2.24,0,0,1,15.56,4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.17,3.5,3.88,7.36.78,4.57a2.25,2.25,0,0,1,0-3.41L1.29.71a2.88,2.88,0,0,1,3.79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.56,13.56l-.5.45a2.9,2.9,0,0,1-3.79,0l-3.1-2.79,4.3-3.86,3.09,2.79A2.24,2.24,0,0,1,15.56,13.56Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.80ab1cdcdb2ab7010523408401e8435f.svg";
export { ForwardRef as ReactComponent };